import { Injectable } from '@angular/core';
import { SlimLoadingBarService, SlimLoadingBarEvent, SlimLoadingBarEventType } from 'ng2-slim-loading-bar';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

@Injectable()
export class LoadingBarService {
    protected inProgressCount = 0;
    private isLoading = new Subject<any>();

    constructor(private slimLoadingBarService: SlimLoadingBarService) {
        this.slimLoadingBarService.events.subscribe((event: SlimLoadingBarEvent) => {
            // If the progress is about to end and there is still async function in progress, we want to stop the loading bar
            if (event.type === SlimLoadingBarEventType.PROGRESS) {
                if (event.value > 95 && this.inProgressCount > 0) {
                    this.slimLoadingBarService.stop();
                } else if (this.inProgressCount > 0) {
                    this.slimLoadingBarService.start();
                    this.isLoading.next(true);
                }
            }
        });
    }

    asyncStart(observable: Subscription) {
        this.slimLoadingBarService.start(() => { });

        this.inProgressCount++;
        this.updateProgress();

        observable.add(() => {
            this.onObservableDone();
        });
    }

    private updateProgress() {
        if (this.inProgressCount > 0) {
            this.slimLoadingBarService.progress = 100 / (this.inProgressCount + 1);
        }
    }

    private onObservableDone() {
        this.inProgressCount--;
        if (this.inProgressCount <= 0) {
            this.slimLoadingBarService.complete();
            this.isLoading.next(false);
        }
    }

    getIsLoading(): Observable<any> {
        return this.isLoading.asObservable();
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/loading-bar/loading-bar.service.ts